<template>
    <div>
        <h2 class="pull-center">Recuperá tu contraseña</h2>
        
        <hr>

        <div class="body-card-border-primary container col-sm-5">
            <div>
                <div class="row">
                    <div class="col-sm-3"></div>
                    
                    <div class="col-sm-6 margin-bottom">
                        <label>Nueva contraseña</label>
                        
                        <input type="password"
                               :class="[errorNewPasswordRequired ? 'is-invalid' : '', 'form-control']"
                               maxlength="16"
                               placeholder="Ingresá la Contraseña"
                               v-model="user.newPassword">

                        <small class="margin-bottom" v-if="errorNewPasswordRequired">Es un campo requerido</small>
                    </div>
                </div>
                
                <div class="row margin-bottom">
                    <div class="col-sm-3"></div>

                    <div class="col-sm-6">
                        <label>Confirmar nueva contraseña</label>
                        
                        <input type="password"
                               :class="[errorConfirmPasswordRequired ? 'is-invalid' : '', 'form-control']"
                               maxlength="16"
                               placeholder="Ingresá la Contraseña"
                               v-model="user.confirmNewPassword">

                        <small class="margin-bottom" v-if="errorConfirmPasswordRequired">Es un campo requerido</small>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-3"></div>

                    <div class="col-sm-6">
                        <small class="margin-bottom" v-if="errorPasswordMissmatch">Los campos no coinciden</small>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12 pull-right">
                        <button class="btn-primary" v-on:click="goBack()">Volver</button>
                        <button class="btn-primary mx-2" v-on:click="postNewPassword()">Enviar</button>
                    </div>
                </div>
            </div>            
        </div>
    </div>
</template>

<script>
import "@/assets/style.css"
import API_ROUTES from '@/api/routes';

export default {
    data() {
        return {
            user: { 
                email: "facu.espilocin@hotmail.com",
                token: "",
                newPassword: "",
                confirmNewPassword: "",
            },
            errorNewPasswordRequired: false,
            errorConfirmPasswordRequired: false,
            errorPasswordMissmatch: false,
        }
    },

    async created() {
        await this.validateToken(new URLSearchParams(window.location.search).get('token'));
    },

    methods: {
        async validateToken(token) {
            // console.log(token);

            if (token != null & token != "") {
                this.user.token = token;
            }
        },

        async postNewPassword() {
            let isValid = this.validateFields();

            // console.log("User in context:");
            // console.log(this.user);

            if (isValid)
            {
                let request = { token : this.user.token, newPassword: this.user.newPassword };

                this.$axios.post(API_ROUTES.POST_USER_RESET_PASSWORD, request)
                .then(res => {
                    //console.log(res);
                    //this.setResetPasswordState("success");
                    window.location.href = "/ForgotPassword/Success";
                })
                .catch(e => {
                    this.showNotification("error", e.response.data);
                })
            }
        },

        validateFields() {
            let result = true;
            
            if (this.user.confirmNewPassword === "") {
                this.errorConfirmPasswordRequired = true;
                return result = false;
            }
            
            if (this.user.newPassword !== this.user.confirmNewPassword) {
                this.errorPasswordMissmatch = true;
                return result = false;
            }

            return result;
        },

        goBack() {
            window.location.href = "/ForgotPassword";
        },

        showNotification(type, text) {
            this.$toasted.show(text, {
                duration: 5000,
                type: type,
                theme: "bubble",
                singleton: true,
                action: {
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                },
            });
        },
    },

    watch: {
        "user.newPassword": function()
        {
            if (this.user.newPassword === "") {
                this.errorNewPasswordRequired = true;
                this.errorPasswordMissmatch = false;
            } else {
                this.errorNewPasswordRequired = false
            }
        },

        "user.confirmNewPassword": function()
        {
            if (this.user.confirmNewPassword === "") {
                this.errorConfirmPasswordRequired = true;
                this.errorPasswordMissmatch = false;
            } else {
                this.errorConfirmPasswordRequired = false
            }
        },
    }
}
</script>